

export let project = [
  {
    key: "name", displayName: "Name", order: 1, type: "string",
    error: "", value: "", helperText: "", required: true,
  },
  {
    key: "client", displayName: "Client", order: 2, type: "string",
    error: "", value: "", helperText: "", required: true,
  },
  {
    key: "desc", displayName: "Description", order: 3, type: "string",
    error: "", value: "", helperText: "", required: true,
  }
];



